import { render, staticRenderFns } from "./sidebarRight.vue?vue&type=template&id=72b7315e&scoped=true"
import script from "./sidebarRight.vue?vue&type=script&lang=js"
export * from "./sidebarRight.vue?vue&type=script&lang=js"
import style0 from "./sidebarRight.vue?vue&type=style&index=0&id=72b7315e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7315e",
  null
  
)

export default component.exports